"use client";
import ErrorBoundaryFallback from "@casino/client/components/ErrorBoundaryFallback";
import { catchError, type ErrorInfo } from "next/error";

type Labels = {
  title: string;
  description: string;
};

const RefreshFallback = (
  { title, description }: Labels,
  { error, retry }: ErrorInfo,
) => (
  <ErrorBoundaryFallback
    error={error instanceof Error ? error : new Error(String(error))}
    reset={retry}
    title={title}
    description={description}
  />
);

const RefreshErrorBoundary = catchError(RefreshFallback);

export default RefreshErrorBoundary;
